<template>
  <div>
    <div class="top-nav-login">
      <b-link class="brand-logo" href="/">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 180 40" class="brand-logo-svg mt-75 ml-5">
            <defs></defs>
            <path id="G" d="M178.65,23.16c-.5.1-.9.2-1.3.3a1.62,1.62,0,0,0-1.3,1.7v5.7a13.59,13.59,0,0,1-2.8,1.1,27.63,27.63,0,0,1-7.5,1,13.33,13.33,0,0,1-9.4-3.9,10.6,10.6,0,0,1-3.1-7.5,11.48,11.48,0,0,1,1-5.5,12.09,12.09,0,0,1,8.7-7.1,14.83,14.83,0,0,1,9.3.8l.9.3a1.43,1.43,0,0,0,2-.8,2.19,2.19,0,0,1,.3-.5c0-.1.1-.1.2-.2h.3a55.38,55.38,0,0,1,.1,8.2,1.09,1.09,0,0,0-.5.1,2.19,2.19,0,0,0-.3-.5,10.8,10.8,0,0,0-1.6-3,8.1,8.1,0,0,0-6.6-3.3,6.63,6.63,0,0,0-4.5,1.5,7.42,7.42,0,0,0-2.3,3.9,17.63,17.63,0,0,0-.7,4,20,20,0,0,0,.7,7.3,6.5,6.5,0,0,0,1.1,2.2,6,6,0,0,0,4.1,2.6,8.64,8.64,0,0,0,5-.5v-6c0-.9-.7-1.5-1.8-1.7a3.4,3.4,0,0,1-1-.1c-.1-.1-.1-.3-.2-.4a.37.37,0,0,1,.3-.1h11C178.65,22.86,178.65,23,178.65,23.16Z" class="path-fill"></path>
            <path id="P" d="M150.85,15a5.52,5.52,0,0,0-3.5-4.9,10.23,10.23,0,0,0-4.2-.9c-3.9-.1-7.8,0-11.7,0-.1,0-.2.1-.3.1,0,.2.1.3.1.4.6.1,1.2.1,1.7.2a1.62,1.62,0,0,1,1.4,1.6v18.4a1.66,1.66,0,0,1-1.6,1.7c-.5.1-1,.1-1.6.2v.5h12v-.5c-.6-.1-1.2-.1-1.8-.2a1.6,1.6,0,0,1-1.4-1.5,2.77,2.77,0,0,1-.1-.9v-6.9a4.33,4.33,0,0,1,.1-.5c1.4-.1,2.8-.1,4.1-.3a8.57,8.57,0,0,0,4.3-1.5A5.25,5.25,0,0,0,150.85,15Zm-5.9,2.6a3.84,3.84,0,0,1-3.5,2.9H140v-10a7.41,7.41,0,0,1,2.1.1c1.8.5,2.8,1.5,3.1,3.8A8.79,8.79,0,0,1,145,17.56Z" class="path-fill"></path>
            <path id="C" d="M128.35,8.66v7.9l-.1.1h-.5a13,13,0,0,0-1.5-3.4,7,7,0,0,0-6.5-3.1,7.15,7.15,0,0,0-6.1,4.3,15.63,15.63,0,0,0-1.2,5.6,18.25,18.25,0,0,0,1,6.6,6.32,6.32,0,0,0,3.5,4,10.55,10.55,0,0,0,2.4.6,8.37,8.37,0,0,0,4.9-1,11.6,11.6,0,0,0,2.1-1.6c.5-.4,1-1,1.6-1.5v2a11.72,11.72,0,0,1-7.2,3.7,14.63,14.63,0,0,1-7.2-.8,10.61,10.61,0,0,1-7-8.4A12.51,12.51,0,0,1,116.15,9a14,14,0,0,1,7.6.5,14.58,14.58,0,0,1,1.9.7,1.41,1.41,0,0,0,2-1,.9.9,0,0,0,.1-.5c.1,0,.2-.1.3-.1S128.15,8.56,128.35,8.66Z" class="path-fill"></path>
            <path id="ny" d="M108.25,9.16c-.1.2-.1.4-.2.5s-.4.1-.6.2a2.61,2.61,0,0,0-1.6,1.1,32.84,32.84,0,0,0-2,3.1c-1.6,2.7-3.3,5.5-4.9,8.2a1.93,1.93,0,0,0-.3,1v6.3c0,1.5.6,2.1,2.2,2.2h1.5c0,.2.1.3.1.4-.2.2-11.2.3-13.1.1v-.5h1.2a5,5,0,0,0,1.2-.2,1.59,1.59,0,0,0,1.2-1.5v-6a1.14,1.14,0,0,0-.3-.8c-2.1-3.8-4.2-7.5-6.3-11.3a14.63,14.63,0,0,0-.9-1.3,2.91,2.91,0,0,0-3.9-.1,3.72,3.72,0,0,0-.7,2v20.1c-.4.3-.6.2-.8-.1l-1.5-1.8c-2.6-3.2-5.2-6.3-7.7-9.5-1.8-2.3-3.7-4.5-5.5-6.8a5,5,0,0,0-.7-.8c0,.2-.1.3-.1.4v14.3a5.85,5.85,0,0,0,.2,1.3,2.25,2.25,0,0,0,1.8,1.7c.5.1,1,.2,1.6.3a.9.9,0,0,1-.1.5h-8.2v-.4a.31.31,0,0,1,.2-.1c.4-.1.7-.1,1.1-.2,1.3-.3,1.8-.8,2.1-2.3a9.7,9.7,0,0,0,.1-1.7V12.76a2.45,2.45,0,0,0-.6-1.6,3.22,3.22,0,0,0-2.8-1.5v-.5c.2-.2,5.4-.2,8.4-.1,1.9,2.3,3.8,4.6,5.6,7s3.7,4.6,5.7,7.1c0-.5.1-.7.1-1v-9.4c0-2.1-.7-2.9-2.9-3.2a.37.37,0,0,1-.3-.1v-.4s15.6-.1,18.1.1v.4c-1.9.4-1.9.4-2.4,1,.2.5.4,1.1.7,1.7,1.2,2.3,2.5,4.6,3.7,6.9.4.7.8,1.4,1.2,2.2.4-.7.8-1.3,1.1-1.9,1.2-2.1,2.5-4.2,3.7-6.3a7.54,7.54,0,0,0,.6-1.3c.4-1,0-1.7-1.1-1.9-.4-.1-.8-.1-1.3-.2a1.09,1.09,0,0,0-.1-.5h7.5Z" class="path-fill"></path>
            <path id="nys" d="M55,35.16a.82.82,0,0,0-1.2-.1c-.1-.3-.3-.7-.4-1-2.5,1.6-1.4,1.4-4.6,1.4h-.4a.75.75,0,0,0-.5.1c-.2.2-.4.4-.5.4h-1.7c-.1,0-.2-.1-.3-.2-.1.1-.2.2-.2.3-.4,0-.7-.1-.9,0a.62.62,0,0,1-.7.2,5.74,5.74,0,0,1-.4.7c-.1-.2-.2-.3-.3-.5a5.72,5.72,0,0,1,.7-.8.94.94,0,0,0,.4-1.4c.4-.3.7-.6,1-.8a4.25,4.25,0,0,1-.2-1.1,17.7,17.7,0,0,1,.1-2.3,13.73,13.73,0,0,0,.2-3.5,5.87,5.87,0,0,1,.4-2.3,9.83,9.83,0,0,1,.5-1.6,8.34,8.34,0,0,0,.6-3.5c0-1.9.1-3.7.2-5.6l-.6-.6c-.3.2-.5.4-.9.7a12.51,12.51,0,0,1,.6-1.8l-.3-1.8a3.09,3.09,0,0,1-.2-.8,2,2,0,0,1,.7-1.5c-.1-1.4-.8-2.5-.7-3.8h.3c0-.2,0-.5.1-.6.3-.3-.2-.5-.1-.7a1.48,1.48,0,0,0,.1-.7,2,2,0,0,1,.1-.7c-.7,0-1.3.1-2,.1-2.7,0-5.4.1-8.1-.1-.1,0-.2.1-.3.1a13.32,13.32,0,0,0-3.9,2.1l-2.1,1.8c-.1.2-.3.4-.3.5.1.6-.5.7-.7,1a5.16,5.16,0,0,1-1.1.2c0,.3.1.4.1.6A8.84,8.84,0,0,0,25.15,9c.2.4.4.7.6,1.1.5-.2.7.2,1,.4-.3.4-.3.4-1.2.6a2.44,2.44,0,0,1,.3,2.8h-1c-1.4.7-2.3,1.9-3.8,2.1a.1.1,0,0,0-.1.1,8.73,8.73,0,0,0-4.3.3,5.54,5.54,0,0,0-2.2-1,1.27,1.27,0,0,1-.6-.1c-.7-.2-1.5.1-2.3-.1-1.9-.3-3.6.4-5.4.9v1.5a.52.52,0,0,0,.4.2c-.1.2-.1.3-.2.5.3.2.5.3.8.5.2.4.3.8.5,1.3a4.63,4.63,0,0,0-2.1,1.7c-.8.5-1.4.8-2,1.2-.4.3-.9.6-1.3.9a8.79,8.79,0,0,0-1,.6v2.2h30.9c.3.4.5.7.8,1.1.5,0,.8.2,1.1.8a7.72,7.72,0,0,1,.2,1.5,8.79,8.79,0,0,1,.6,1,5.64,5.64,0,0,1,1.2.4,3.33,3.33,0,0,1,.6.3,1.94,1.94,0,0,0,1.1.9c.9.5,1.9,1,2.8,1.5.6.3,1.2.7,1.8,1-.1,1.2-1.1,2-.8,3.2a1.4,1.4,0,0,0,1.5.3,29.92,29.92,0,0,0,3.2-.8c.5-.1,1-.3,1.5-.4a3.64,3.64,0,0,1,1.4-.2c.6.1.9-.2,1.4-.4h.3c.4.1.6-.1.9-.3a1.52,1.52,0,0,1,.8-.4c.4.1.6-.1.9-.2,1-.4,1.9-.8,2.8-1.2.1-.1.2-.1.4-.2C56,34.46,55.55,35.06,55,35.16Z" class="path-fill"></path>
        </svg>
      </b-link>
    </div>
    <div class="auth-wrapper auth-v1 px-2">
      <b-card no-body class="mb-0 account-body">
          <b-card-body class="p-0 m-0">
            <b-card-title
              class="mb-1 mt-2 font-weight-bold justify-content-between"
              style="text-align: center; font-size: 24px; color: #7f1d1a; font-weight: 500; font-family: inherit;"
              title-tag="h2"
            >
              Welcome to NYCPG Portal
            </b-card-title>

            <!-- ─── PASO 1: Formulario de login normal ─── -->
            <div v-if="!showOtpInput">
              <b-card-text class="mb-25 text-primary justify-content-between" style="text-align: center;">
                Please sign in
              </b-card-text>

              <validation-observer ref="loginForm" #default="{invalid}">
                <b-form
                  class="auth-login-form mt-2"
                  @submit.prevent="ingresoUsuario({ email: userEmail, password })"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Email"
                    vid="email"
                    rules="required|email"
                  >
                    <b-form-input
                      id="login-email"
                      v-model="userEmail"
                      :state="errors.length > 0 ? false : null"
                      name="login-email"
                      placeholder="Email Address"
                      tabindex="1"
                      class="mb-0"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>

                  <validation-provider
                    #default="{ errors }"
                    name="password"
                    vid="password"
                    rules="required"
                  >
                    <b-input-group
                      class="input-group-merge mt-1"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                    >
                      <b-form-input
                        id="login-password"
                        v-model="password"
                        :state="errors.length > 0 ? false : null"
                        class="form-control-merge"
                        :type="passwordFieldType"
                        name="login-password"
                        placeholder="Password"
                        tabindex="2"
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                          class="cursor-pointer"
                          :icon="passwordToggleIcon"
                          @click="togglePasswordVisibility"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>

                  <b-button
                    type="submit"
                    variant="primary"
                    block
                    :disabled="invalid || loadingLogin"
                    tabindex="3"
                    class="mt-1"
                  >
                    <b-spinner v-if="loadingLogin" small class="mr-50" />
                    {{ loadingLogin ? 'Signing in...' : 'Sign in' }}
                  </b-button>

                  <div class="mt-1 mb-50" style="text-align: center;">
                    <b-link :to="{ name: 'auth-forgot-password' }">
                      <small>Forgot password</small>
                    </b-link> •
                    <b-link href="mailto:portalhelp@nycpg.org">
                      <small>Contact us</small>
                    </b-link> •
                    <b-link v-b-modal.modal-1>
                      <small>Need Help?</small>
                    </b-link>
                  </div>
                  <div class="mt-0 mb-2" style="text-align: center;">
                    <b-link :to="{ name: 'terms-of-use' }">
                      <small>Terms of Use</small>
                    </b-link> •
                    <b-link :to="{ name: 'privacy-policy' }">
                      <small>Privacy Policy</small>
                    </b-link>
                  </div>
                </b-form>
              </validation-observer>
            </div>

            <!-- ─── PASO 2: Verificación del código OTP ─── -->
            <div v-else class="otp-section">
              <b-card-text class="mb-25 text-primary" style="text-align: center;">
                Two-Factor Authentication
              </b-card-text>
              <p class="text-center text-muted mb-1" style="font-size: 13px;">
                A 6-digit verification code was sent to<br>
                <strong>{{ userEmail }}</strong>
              </p>

              <!-- Inputs individuales por dígito -->
              <div class="otp-inputs d-flex justify-content-center mb-1">
                <input
                  v-for="(digit, index) in otpDigits"
                  :key="index"
                  :ref="`otpInput${index}`"
                  v-model="otpDigits[index]"
                  class="otp-digit-input"
                  type="text"
                  maxlength="1"
                  inputmode="numeric"
                  autocomplete="one-time-code"
                  @input="onOtpInput(index, $event)"
                  @keydown="onOtpKeydown(index, $event)"
                  @paste="onOtpPaste($event)"
                />
              </div>

              <!-- Contador de expiración -->
              <p v-if="otpTimeLeft > 0" class="text-center text-muted" style="font-size: 12px;">
                Code expires in <strong>{{ otpTimeLeftFormatted }}</strong>
              </p>
              <p v-else class="text-center text-danger" style="font-size: 12px;">
                Code expired.
                <b-link @click="reenviarCodigo" class="font-weight-bold">Send a new one</b-link>
              </p>

              <b-button
                variant="primary"
                block
                :disabled="otpCode.length !== 6 || loadingOtp || otpTimeLeft === 0"
                class="mt-50"
                @click="verificarOtp"
              >
                <b-spinner v-if="loadingOtp" small class="mr-50" />
                {{ loadingOtp ? 'Verifying...' : 'Verify Code' }}
              </b-button>

              <b-button
                variant="flat-secondary"
                block
                class="mt-50"
                :disabled="loadingOtp"
                @click="cancelarOtp"
              >
                ← Back to login
              </b-button>

              <p v-if="otpTimeLeft > 0" class="text-center mt-50 mb-1" style="font-size: 12px;">
                Didn't receive it?
                <b-link
                  :disabled="resendCooldown > 0"
                  @click="reenviarCodigo"
                  style="font-size: 12px;"
                >
                  {{ resendCooldown > 0 ? `Resend in ${resendCooldown}s` : 'Resend code' }}
                </b-link>
              </p>
            </div>

          </b-card-body>
      </b-card>

      <b-modal id="modal-1" title="Need Help?" hide-footer>
        <b-card-text>
          <p>For questions or more information, please contact:</p>
          <span>Email: <span class="text-primary">portalhelp@nycpg.org</span></span><br>
        </b-card-text>
      </b-modal>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup,
  BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton, BAlert,
  VBTooltip, BImgLazy, BCard, BCardBody, BModal, VBModal, BSpinner,
} from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'
import Ripple from 'vue-ripple-directive'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store/index'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import { firebase, auth, db } from '@/firebase'
import { mapActions, mapState, mapMutations } from 'vuex'
import moment from 'moment'
import router from '@/router'
import axios from 'axios'

// ── Cambia esto por la URL base de tu servidor Node.js ──
const API_BASE_URL = 'https://authsys-40647711281.us-central1.run.app'

export default {
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
    'b-modal': VBModal,
  },
  components: {
    BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup,
    BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton, BAlert,
    BImgLazy, BCard, BCardBody, BModal, BSpinner, VuexyLogo,
    ValidationProvider, ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      password: '',
      userEmail: '',
      sideImg: require('@/assets/images/pages/login-v2.svg'),
      required,
      email,

      // ── Estado 2FA ──
      showOtpInput: false,        // Mostrar pantalla OTP
      otpDigits: ['', '', '', '', '', ''], // Dígitos individuales
      loadingLogin: false,        // Spinner del botón Sign in
      loadingOtp: false,          // Spinner del botón Verify
      pendingUserData: null,      // Datos del doc de Firestore
      pendingIdToken: null,       // ID Token Firebase (válido 1h aunque se haga signOut)
      pendingCredentials: null,   // { email, password } para re-autenticar tras OTP

      // Temporizador OTP
      otpTimeLeft: 0,            // Segundos restantes
      otpTimer: null,            // Referencia al interval
      resendCooldown: 0,         // Cooldown para reenvío
      resendTimer: null,
    }
  },
  metaInfo: {
    meta: [{ name: 'title', content: 'Login' }],
  },
  computed: {
    ...mapState(['usuario']),
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
    // Código OTP unificado desde los 6 dígitos individuales
    otpCode() {
      return this.otpDigits.join('')
    },
    // Formato mm:ss para el contador
    otpTimeLeftFormatted() {
      const m = Math.floor(this.otpTimeLeft / 60)
      const s = this.otpTimeLeft % 60
      return `${m}:${s.toString().padStart(2, '0')}`
    },
  },
  mounted() {
    // Restaurar estado OTP si el componente fue remontado por el router guard
    // (auth.signOut() dispara onAuthStateChanged → guard navega a /login → remount)
    const saved = sessionStorage.getItem('otp_pending')
    if (saved) {
      try {
        const { pendingIdToken, pendingUserData, pendingCredentials, userEmail } = JSON.parse(saved)
        this.pendingIdToken = pendingIdToken
        this.pendingUserData = pendingUserData
        this.pendingCredentials = pendingCredentials
        this.userEmail = userEmail
        this.showOtpInput = true
        this.iniciarContador(900)
        this.resendCooldown = 30
        this.resendTimer = setInterval(() => {
          if (this.resendCooldown > 0) this.resendCooldown--
          else clearInterval(this.resendTimer)
        }, 1000)
      } catch (e) {
        sessionStorage.removeItem('otp_pending')
      }
    }
  },
  beforeDestroy() {
    this.clearTimers()
  },
  methods: {
    ...mapMutations(['nuevoUsuario']),

    // ────────────────────────────────────────────────
    // LOGIN PRINCIPAL
    // ────────────────────────────────────────────────
    async ingresoUsuario(usuario) {
      this.loadingLogin = true
      try {
        const signIn = await auth.signInWithEmailAndPassword(usuario.email, usuario.password)
        const doc = await db.collection('usuarios').doc(signIn.user.uid).get()

        if (!doc.exists) {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: { title: 'Error', icon: 'CoffeeIcon', variant: 'error', text: 'User does not exist' },
          })
          await auth.signOut()
          return
        }

        // Guardar token y datos ANTES de hacer signOut
        // El ID token de Firebase sigue siendo válido 1 hora aunque se haga signOut en cliente
        this.pendingIdToken = await signIn.user.getIdToken()
        this.pendingUserData = doc.data()
        this.pendingCredentials = { email: usuario.email, password: usuario.password }

        // Persistir en sessionStorage ANTES del signOut para sobrevivir el remount
        // que dispara el router guard al detectar onAuthStateChanged(null)
        sessionStorage.setItem('otp_pending', JSON.stringify({
          pendingIdToken: this.pendingIdToken,
          pendingUserData: this.pendingUserData,
          pendingCredentials: this.pendingCredentials,
          userEmail: usuario.email,
        }))

        // auth.signOut() dispara onAuthStateChanged(null) → router guard → remount del componente
        // El mounted() restaura el estado desde sessionStorage automáticamente
        await auth.signOut()

        // Enviar código y mostrar pantalla OTP
        await this.enviarCodigoOtp()
        this.showOtpInput = true

      } catch (error) {
        this.mostrarErrorLogin(error)
      } finally {
        this.loadingLogin = false
      }
    },

    // ────────────────────────────────────────────────
    // ENVIAR CÓDIGO OTP AL EMAIL
    // ────────────────────────────────────────────────
    async enviarCodigoOtp() {
      await axios.post(
        `${API_BASE_URL}/send-code`,
        {},
        { headers: { Authorization: `Bearer ${this.pendingIdToken}` } }
      )

      // Notificar al usuario que se envió el código
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: 'Verification code sent',
          icon: 'MailIcon',
          variant: 'success',
          text: `A 6-digit code was sent to ${this.userEmail}`,
        },
      })

      // Iniciar countdown de 5 minutos
      this.iniciarContador(900)

      // Cooldown de 30 segundos para reenvío
      this.resendCooldown = 30
      this.resendTimer = setInterval(() => {
        if (this.resendCooldown > 0) {
          this.resendCooldown--
        } else {
          clearInterval(this.resendTimer)
        }
      }, 1000)
    },

    async reenviarCodigo() {
      if (this.resendCooldown > 0) return
      try {
        // El usuario está deslogueado, re-autenticar temporalmente para obtener token fresco
        const signIn = await auth.signInWithEmailAndPassword(
          this.pendingCredentials.email,
          this.pendingCredentials.password
        )
        this.pendingIdToken = await signIn.user.getIdToken()
        await auth.signOut() // volver a desloguear inmediatamente

        await this.enviarCodigoOtp()
        this.otpDigits = ['', '', '', '', '', '']
        this.$nextTick(() => {
          if (this.$refs.otpInput0 && this.$refs.otpInput0[0]) {
            this.$refs.otpInput0[0].focus()
          }
        })
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: { title: 'Error', icon: 'AlertCircleIcon', variant: 'error', text: 'Could not resend the code.' },
        })
      }
    },

    // ────────────────────────────────────────────────
    // VERIFICAR CÓDIGO OTP
    // ────────────────────────────────────────────────
    async verificarOtp() {
      if (this.otpCode.length !== 6) return
      this.loadingOtp = true
      try {
        const response = await axios.post(
          `${API_BASE_URL}/verify-code`,
          { code: this.otpCode },
          { headers: { Authorization: `Bearer ${this.pendingIdToken}` } }
        )

        if (response.data.success) {
          this.clearTimers()
          sessionStorage.removeItem('otp_pending')
          // Re-autenticar con Firebase para crear la sesión real.
          // El usuario estaba deslogueado para evitar que el router guard
          // redirigiera al dashboard antes de completar el 2FA.
          const signIn = await auth.signInWithEmailAndPassword(
            this.pendingCredentials.email,
            this.pendingCredentials.password
          )
          await this.completarLogin(signIn.user, this.pendingUserData)
        }
      } catch (error) {
        const msg = error.response?.data?.error || 'Invalid or expired code.'
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: { title: 'Verification failed', icon: 'AlertCircleIcon', variant: 'error', text: msg },
        })
        this.otpDigits = ['', '', '', '', '', '']
        this.$nextTick(() => {
          if (this.$refs.otpInput0 && this.$refs.otpInput0[0]) {
            this.$refs.otpInput0[0].focus()
          }
        })
      } finally {
        this.loadingOtp = false
      }
    },

    // ────────────────────────────────────────────────
    // CANCELAR 2FA Y VOLVER AL LOGIN
    // ────────────────────────────────────────────────
    async cancelarOtp() {
      this.clearTimers()
      sessionStorage.removeItem('otp_pending')
      this.showOtpInput = false
      this.otpDigits = ['', '', '', '', '', '']
      this.pendingUserData = null
      this.pendingIdToken = null
      this.pendingCredentials = null
    },

    // ────────────────────────────────────────────────
    // COMPLETAR LOGIN (lógica de roles existente)
    // ────────────────────────────────────────────────
    async completarLogin(firebaseUser, userData) {
      const role = userData.role

      if (role === 'clinician' || role === 'clinician-staff') {
        if (role === 'clinician-staff') {
          if (!userData.dependency) {
            return this.signOutWithMessage('Your account is disable, contact support to reactivate.')
          }
          const itemClinician = await db.collection('usuarios').doc(userData.dependency).get()
          const programClinician = itemClinician.data()?.program || ''

          if (programClinician !== 'PGRC - Group Practice' && programClinician !== 'PGRC - OASAS Program') {
            return this.signOutWithMessage('Your account is disable, contact support to reactivate.')
          }
        }

        if (userData.status === 'inactive') {
          return this.signOutWithMessage('Your account is disable, contact support to reactivate.')
        }
        if (userData.statusReferral === 'inactive') {
          return this.signOutWithMessage('Your account is disable, contact support to reactivate.')
        }

        // Verificar fecha de expiración
        const queryTrack = await db
          .collection('usuarios').doc(firebaseUser.uid)
          .collection('details').doc('trackingDetail').get()

        if (!queryTrack.exists || !queryTrack.data().datePickers?.[9]?.value) {
          return this.signOutWithMessage('Your account is expired, contact support to reactivate.')
        }

        const formatDate = moment(queryTrack.data().datePickers[9].value, 'MM/DD/YYYY').format('MM/DD/YYYY')
        const dateExpired = parseInt(moment(formatDate).format('x'), 10)
        const days = (new Date(dateExpired) - new Date()) / (1000 * 3600 * 24)

        if (Math.trunc(days) <= 0) {
          return this.signOutWithMessage('Your account is expired, contact support to reactivate.')
        }

        this.finalizarSesion(userData)

      } else if (role === 'staff' || role) {
        // staff y cualquier otro rol → acceso directo
        this.finalizarSesion(userData)
      }
    },

    // ────────────────────────────────────────────────
    // HELPERS
    // ────────────────────────────────────────────────
    finalizarSesion(userData) {
      this.nuevoUsuario(userData)
      this.$ability.update(userData.ability)
      this.$router.replace(getHomeRouteForLoggedInUser(userData.role)).then(() => {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: { title: `Welcome back ${userData.nombre}`, icon: 'CoffeeIcon', variant: 'success' },
        })
      })
    },

    signOutWithMessage(text) {
      auth.signOut().then(() => {
        this.showOtpInput = false
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: { title: text, icon: 'CoffeeIcon', variant: 'warning' },
        })
      })
    },

    mostrarErrorLogin(error) {
      const msgs = {
        'auth/wrong-password': 'Incorrect password.',
        'auth/user-not-found': 'Incorrect email or password.',
      }
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: 'Error',
          icon: 'CoffeeIcon',
          variant: 'error',
          text: msgs[error.code] || 'Incorrect email or password.',
        },
      })
    },

    iniciarContador(segundos) {
      clearInterval(this.otpTimer)
      this.otpTimeLeft = segundos
      this.otpTimer = setInterval(() => {
        if (this.otpTimeLeft > 0) {
          this.otpTimeLeft--
        } else {
          clearInterval(this.otpTimer)
        }
      }, 1000)
    },

    clearTimers() {
      clearInterval(this.otpTimer)
      clearInterval(this.resendTimer)
    },

    // ── Manejo de inputs OTP individuales ──
    onOtpInput(index, event) {
      const val = event.target.value.replace(/\D/g, '')
      this.$set(this.otpDigits, index, val ? val[0] : '')
      if (val && index < 5) {
        const nextRef = this.$refs[`otpInput${index + 1}`]
        if (nextRef && nextRef[0]) nextRef[0].focus()
      }
      // Auto-verificar cuando se completan los 6 dígitos
      if (this.otpCode.length === 6 && this.otpTimeLeft > 0) {
        this.$nextTick(() => this.verificarOtp())
      }
    },

    onOtpKeydown(index, event) {
      if (event.key === 'Backspace' && !this.otpDigits[index] && index > 0) {
        const prevRef = this.$refs[`otpInput${index - 1}`]
        if (prevRef && prevRef[0]) prevRef[0].focus()
      }
    },

    onOtpPaste(event) {
      event.preventDefault()
      const pasted = (event.clipboardData || window.clipboardData)
        .getData('text').replace(/\D/g, '').slice(0, 6)
      pasted.split('').forEach((char, i) => {
        this.$set(this.otpDigits, i, char)
      })
      const lastRef = this.$refs[`otpInput${Math.min(pasted.length, 5)}`]
      if (lastRef && lastRef[0]) lastRef[0].focus()
      if (pasted.length === 6 && this.otpTimeLeft > 0) {
        this.$nextTick(() => this.verificarOtp())
      }
    },

    // Google login (sin cambios)
    google() {
      const provider = new firebase.auth.GoogleAuthProvider()
      this.ingresar(provider)
    },
    async ingresar(provider) {
      firebase.auth().languageCode = 'en'
      try {
        const result = await firebase.auth().signInWithPopup(provider)
        const user = result.user
        const usuario = {
          nombre: user.displayName,
          email: user.email,
          uid: user.uid,
          foto: user.photoURL,
          role: 'clinician',
          ability: [{ action: 'manage', subject: 'all' }],
        }
        this.nuevoUsuario(usuario)
        await db.collection('usuarios').doc(usuario.uid).set(usuario)
        this.$ability.update(usuario.ability)
        this.$router.replace(getHomeRouteForLoggedInUser(usuario.role))
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>

<style>
.modal .modal-header .close {
  transform: none; box-shadow: none; border-radius: unset; background: none;
}
.modal .modal-header .close:hover { transform: translate(2px, 2px); }
.top-nav-login {
  background-color: #94221e;
  border: none; height: 65px; top: 0px;
  position: absolute; width: 100%;
}
.brand-logo-svg { fill: white; height: 38px; }
.account-body {
  position: relative;
  padding: 35px 30px 10px;
  margin-bottom: 1em;
  color: #444;
  background-color: #fff;
  border: 1px solid #ddd;
  -webkit-box-shadow: 1px 1px 1px rgba(0,0,0,.15);
  box-shadow: 1px 1px 1px rgba(0,0,0,.15);
  border-radius: 4px;
  width: 450px;
}

/* ── OTP Inputs ── */
.otp-inputs { gap: 10px; }
.otp-digit-input {
  width: 44px;
  height: 52px;
  text-align: center;
  font-size: 22px;
  font-weight: 600;
  border: 2px solid #ddd;
  border-radius: 8px;
  outline: none;
  transition: border-color 0.2s;
  color: #7f1d1a;
}
.otp-digit-input:focus {
  border-color: #94221e;
  box-shadow: 0 0 0 3px rgba(148, 34, 30, 0.15);
}
</style>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
.text-card-register { font-size: 15px; }
</style>